import React from 'react';
import { motion } from 'framer-motion';
import { format } from 'date-fns';
import Icon from '../../../components/AppIcon';


const ProgressPhotoCard = ({ photo, onDelete, isClient }) => {
  return (
    <motion.div
      className="bg-card border border-border rounded-xl overflow-hidden hover:shadow-lg transition-shadow"
      whileHover={{ y: -4 }}
    >
      <div className="aspect-square relative">
        {photo?.signedUrl ? (
          <img
            src={photo?.signedUrl}
            alt={photo?.caption || 'Progress photo'}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-muted flex items-center justify-center">
            <Icon name="Image" size={48} className="text-muted-foreground" />
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="flex justify-between items-start mb-3">
          <div>
            <p className="text-sm font-medium text-foreground">
              {format(new Date(photo?.takenAt), 'MMM dd, yyyy')}
            </p>
            {photo?.caption && (
              <p className="text-sm text-muted-foreground mt-1">{photo?.caption}</p>
            )}
          </div>
          {isClient && (
            <button
              onClick={() => onDelete(photo?.id, photo?.photoUrl)}
              className="text-destructive hover:text-destructive/80"
            >
              <Icon name="Trash2" size={18} />
            </button>
          )}
        </div>

        <div className="grid grid-cols-2 gap-3">
          {photo?.weight && (
            <div className="flex items-center gap-2 text-sm">
              <Icon name="Weight" size={16} className="text-muted-foreground" />
              <span className="text-foreground">{photo?.weight} lbs</span>
            </div>
          )}
          {photo?.bodyFatPercentage && (
            <div className="flex items-center gap-2 text-sm">
              <Icon name="Percent" size={16} className="text-muted-foreground" />
              <span className="text-foreground">{photo?.bodyFatPercentage}% BF</span>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ProgressPhotoCard;